import { render, staticRenderFns } from "./tab-rejected.vue?vue&type=template&id=514d3202&scoped=true"
import script from "./tab-rejected.vue?vue&type=script&lang=js"
export * from "./tab-rejected.vue?vue&type=script&lang=js"
import style0 from "./tab-rejected.vue?vue&type=style&index=0&id=514d3202&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514d3202",
  null
  
)

export default component.exports